var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommercialZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18705 1.3999H2V5.76973",
    stroke: "#888888",
    strokeWidth: 2.17762,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.813 18.5674L18 18.5674L18 14.1976",
    stroke: "#888888",
    strokeWidth: 2.17762,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1976L2 18.5674L6.18705 18.5674",
    stroke: "#888888",
    strokeWidth: 2.17762,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.76973L18 1.3999L13.813 1.3999",
    stroke: "#888888",
    strokeWidth: 2.17762,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36719 5.26978V14.6337H10.601V5.26978H5.36719ZM6.27445 5.76961H7.44393V6.79221H6.27445V5.76961ZM6.27445 7.48006H7.44393V8.50266H6.27445V7.48006ZM6.27445 9.12173H7.44393V10.1443H6.27445V9.12173ZM6.27445 10.7634H7.44393V11.786H6.27445V10.7634ZM8.59767 14.4869H7.36002V12.7811H8.59767V14.4869ZM9.85631 11.786H8.68683V10.7634H9.85631V11.786ZM9.85631 10.1443H8.68683V9.12173H9.85631V10.1443ZM9.85631 8.50266H8.68683V7.48006H9.85631V8.50266ZM9.85631 6.79221H8.68683V5.76961H9.85631V6.79221Z",
    fill: "#888888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 9.17188V14.6342H15.0861V9.17188H11.3477ZM11.9957 10.0165H12.831V10.8732H11.9957V10.0165ZM11.9957 11.3918H12.831V12.2485H11.9957V11.3918ZM13.6551 14.5112H12.7711V13.0822H13.6551V14.5112ZM14.5542 12.2485H13.7188V11.3918H14.5542V12.2485ZM14.5542 10.8732H13.7188V10.0165H14.5542V10.8732Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialZones);
export default __webpack_public_path__ + "static/media/commercialZones.e920c9b9e37ada9c62fc7bef0b9f5d8f.svg";
export { ForwardRef as ReactComponent };